import { ThreeDotsLoader, Dot } from './Loader.styled';
import Loader, { Loader as NotPureLoader } from './Loader';
import * as Types from './Loader.d';

export { ThreeDotsLoader, NotPureLoader as Loader, Dot };
export type LoaderProps = Types.LoaderProps;
export default Loader;
